module.exports = __webpack_public_path__ + "static/landing-vid-07e52a5d7e5b3035a24a39df1ee2b5e6.mp4";